const initialState = {
  sendMessageBegin: false,
  sendMessageSuccess: false,
  sendMessageFailure: false,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/login/redux/initialState.js